import client from './client'

const fetchContact = () => {
  return client.get('/items/contact', {
    fields: ['netfang', 'simi', 'simi_texti', 'opnunartimi', 'tolvupostur_texti'],
    single: 1,
  })
}

export default fetchContact
